import React from 'react';
import { Dropdown } from 'antd';
import { DownOutlined } from '@ant-design/icons';

import { useActionButtons } from '../../hooks';
import s from './styles.module.scss';

import type { FC } from 'react';
import type { MenuProps } from 'antd';

interface ReportButtonsProps {
  patientGuid: string;
  disabledCreateInternalAdmissionForms?: boolean;
}

export const ReportButtons: FC<ReportButtonsProps> = ({
  patientGuid,
  disabledCreateInternalAdmissionForms,
}) => {
  const { combinedActionDropdownButtons } = useActionButtons({
    patientGuid,
    disabledCreateInternalAdmissionForms,
  });

  return (
    <div className={s['report-grid']}>
      {combinedActionDropdownButtons.map((b) => {
        const menuItems: MenuProps['items'] = b.options.map(
          (option, index) => ({
            key: index,
            label: option.label,
            onClick: option.handleClick,
            'data-cy': option.dataCy,
          }),
        );

        return (
          <Dropdown
            key={b.key}
            menu={{ items: menuItems }}
            trigger={['click']}
            disabled={b.disabled || b.loading}
            rootClassName={s['report-dropdown-menu']}
          >
            <button
              className={s['report-button']}
              data-cy={b.dataCy}
              disabled={b.disabled || b.loading}
            >
              <span className={s['report-button-label']}>{b.label}</span>
              <DownOutlined className={s['report-button-arrow']} />
            </button>
          </Dropdown>
        );
      })}
    </div>
  );
};
